import { faExclamation } from "@fortawesome/free-solid-svg-icons";
import { useAtendimentoPage } from "../../../../../../Context/AtendimentoPage";
import { ValidarSolicitacaoNaoProcedenteController } from "../../../../../../Controllers/AssistenciaTecnica/Atendimento/AcoesAtendimento/AcoesAtendimentoControllers";
import useAsyncCallback from "../../../../../../hooks/useAsyncCallback";
import IconOrSpinner from "../../../../../../Components/Utils/IconOrSpinner";
import { useHistoricoContext } from "../../../../../../Context/Historico";
import { IAtendimentoExtraDetalhado } from "../../../../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import { IAcoesAcessoUsuario } from "../../../../../../Interfaces/Geral/AcaoEtapa/AcaoEtapaInterfaces";
interface IBotaoValidarSolicitacaoNaoProcedenteProps {
    AcaoAcessoUsuario: IAcoesAcessoUsuario[] | undefined;
}

export default function BotaoValidarSolicitacaoNaoProcedente(
    props: IBotaoValidarSolicitacaoNaoProcedenteProps
) {
    const { updateAtendimento, Atendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    const AtendimentoDetalhado = Atendimento as IAtendimentoExtraDetalhado;

    const {
        execute: ValidarSolicitacaoNaoProcedente,
        loading: ValidarSolicitacaoNaoProcedenteLoading,
    } = useAsyncCallback(ValidarSolicitacaoNaoProcedenteController);

    return (
        <button
            type="button"
            className="btn btn-sm btn-primary m-1"
            disabled={
                !props.AcaoAcessoUsuario?.find(
                    (acaoFiltrada) => acaoFiltrada.ID_ACAO === 30
                )?.FL_USUARIO_ACESSA ||
                ValidarSolicitacaoNaoProcedenteLoading ||
                AtendimentoDetalhado.FL_SINCRONIZADO === true
            }
            onClick={() => {
                if (Atendimento?.ID_CASO) {
                    ValidarSolicitacaoNaoProcedente(Atendimento.ID_CASO).then(
                        () => {
                            updateAtendimento();
                            ReloadHistorico();
                        }
                    );
                }
            }}
        >
            <IconOrSpinner
                icon={faExclamation}
                loadingSize="sm"
                loading={ValidarSolicitacaoNaoProcedenteLoading}
                className="mr-2"
            />{" "}
            Solicitação Procedente
        </button>
    );
}
